<template>
  <div>
    <v-dialog
      v-model="dialogShow"
      @keydown.esc.prevent="closeForm"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-form v-model="valid"></v-form>
      <div v-if="isItemModified"></div>
      <div v-if="formMode"></div>
      <v-card>
        <v-form v-model="valid" ref="form">
          <v-toolbar dark color="brown" class="color-gradient-1" dense>
            <v-btn icon dark @click="closeForm">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ lookupFDivision(this.currentDivision) }}</v-toolbar-title
            >
            <v-spacer></v-spacer>

            <v-toolbar-items>
              <button icon @click.stop.prevent="copyTestingCode">
                <v-icon>mdi-share-variant</v-icon>
              </button>
              <v-btn
                dark
                text
                @click="save"
                :disabled="!valid || isItemModified === false"
                class="hidden-md-and-up"
              >
                Simpan
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-title class="text-uppercase grey--text">
            <span v-if="formMode === 'EDIT_FORM'">EDIT </span>
            <span class="font-weight-light ml-1 mr-1">ITEM</span>
            <span v-if="formMode === 'NEW_FORM'"> BARU</span>
            <v-chip
              class="ma-2"
              color="warning"
              outlined
              x-small
              v-show="isItemModified"
            >
              <v-icon left> mdi-pencil </v-icon>
              modfied
            </v-chip>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-tabs>
                <v-tab>Gallery</v-tab>
                <v-tab>Dokumen</v-tab>
                <v-tab>Team</v-tab>
                <v-tab>Bahan-Material</v-tab>
                <v-tab-item>
                  <FPengawasanKemajuanFisikGallery
                    :itemModified="itemModified"
                    :parendId="itemModified.id"
                    :itemsFile="itemsFile"
                    @retrieveFiles="retrieveFiles"
                  ></FPengawasanKemajuanFisikGallery>
                </v-tab-item>
                <v-tab-item>
                  <FPengawasanKemajuanFisikDoc
                    :itemModified="itemModified"
                    :parendId="itemModified.id"
                    :itemsFile="itemsFile"
                    @retrieveFiles="retrieveFiles"
                  >
                  </FPengawasanKemajuanFisikDoc>
                </v-tab-item>
                <v-tab-item>
                  <FPengawasanKemajuanFisikItem
                    :itemModified="itemModified"
                    :itemsFDivision="itemsFDivision"
                    :itemsFPegawai="itemsFPegawai"
                    :itemsFCvpt="itemsFCvpt"
                  ></FPengawasanKemajuanFisikItem>
                </v-tab-item>
                <v-tab-item>
                  <FKegiatanMaterialBahan></FKegiatanMaterialBahan>
                </v-tab-item>
              </v-tabs>
            </v-container>
          </v-card-text>

          <v-card-actions v-if="false">
            <v-chip
              class="ml-4"
              color="error"
              outlined
              close
              small
              v-show="formDialogOptions.errorMessage"
            >
              {{ formDialogOptions.errorMessage }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="closeForm"
              class="hidden-sm-and-down"
            >
              Batal
            </v-btn>
            <v-btn
              color="blue darken-1"
              outlined
              text
              @click="save"
              :disabled="!valid || isItemModified === false"
              class="hidden-sm-and-down"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>

      <close-confirm-dialog
        ref="refCloseConfirmDialog"
        @eventFromCloseConfirm="passingEventFromCloseConfirm"
      ></close-confirm-dialog>
    </v-dialog>
  </div>
</template>

<script>
import FKegiatanService from "@/services/apiservices/f-kegiatan-service";
import FDivision from "@/models/f-division";
import FCvpt from "@/models/f-cvpt";
import FPegawai from "@/models/f-pegawai";
import FKegiatanTeam from "@/models/f-kegiatan-team";

import CloseConfirmDialog from "@/components/utils/CloseConfirmDialog";
import FormMode from "@/models/form-mode";
import FKegiatan from "@/models/f-kegiatan";
import { format, parseISO } from "date-fns";
import FPengawasanKemajuanFisikItem from "./FKegiatanMaterialItem";
import FPengawasanKemajuanFisikDoc from "./FKegiatanMaterialDoc";
import FPengawasanKemajuanFisikGallery from "./FKegiatanMaterialGallery";
import FKegiatanFileService from "@/services/apiservices/f-kegiatan-file-service";
import FKegiatanMaterialBahan from "@/components/rantai_pasok_bahan/kebutuhan_bahan/FKegiatanMaterialBahan";
import FKegiatanMaterialService from "@/services/apiservices/f-kegiatan-material-service";

export default {
  components: {
    FKegiatanMaterialBahan,
    FPengawasanKemajuanFisikDoc,
    FPengawasanKemajuanFisikGallery,
    FPengawasanKemajuanFisikItem,
    CloseConfirmDialog,
  },
  props: {
    formMode: String,
    currentDivision: Number,
  },
  data() {
    return {
      message: "Copy These Text",

      dialogShow: false,
      formDialogOptions: {
        title1: "",
        title2: "",
        message1: "",
        message2: "",
        errorMessage: "",
        color: "grey lighten-3",
        width: 800,
        zIndex: 200,
        noconfirm: false,
      },
      date: format(parseISO(new Date().toISOString()), "dd-MMM-yyyy"),
      menuDate1: false,
      menuDate2: false,
      menuDate3: false,

      selectedItemIndex: -1,
      itemDefault: "",
      itemModified: new FKegiatan(0, "", ""),
      selectFDivision: { id: 0, kode1: "", description: "" },
      itemsFDivision: [new FDivision()],
      itemsFCvpt: [new FCvpt()],
      itemsFPegawai: [new FPegawai()],
      fkegiatanTeams: [new FKegiatanTeam()],
      itemsFile: [],

      valid: false,
      rulesLenght: [
        (v) => !!v || " Tidak Boleh Kosong",
        (v) => v.length <= 255 || "Maksimal 255 Karakter",
        (v) => v.length > 1 || "Harus lebih besar dari 1 karakter",
      ],
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],
    };
  },
  computed: {
    isItemModified() {
      const defaultItem = JSON.stringify(this.itemDefault);
      const modifiedItem = JSON.stringify(this.itemModified);
      return defaultItem !== modifiedItem;
    },
  },

  watch: {},

  methods: {
    copyTestingCode() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        alert("Testing code was copied " + msg);
      } catch (err) {
        alert("Oops, unable to copy");
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },

    onCopy: function (e) {
      alert("You just copied: " + e.text);
    },
    onError: function (e) {
      alert("Failed to copy texts" + e.text);
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd-MMM-yyyy") : "";
    },

    showDialog(selectedIndex, item, itemsFDivision, itemsFCvpt, itemsFPegawai) {
      // console.log("show UserDialog " + item.id)
      // console.log(this.formMode)
      this.dialogShow = !this.dialogShow;
      if (selectedIndex > -1) {
        this.selectedIndex = selectedIndex;
        this.initializeEditMode(item);
      } else {
        (this.itemDefault = new FKegiatan(0, "", "")),
          (this.itemModified = new FKegiatan(0, "", "")),
          (this.selectedIndex = -1);
      }

      this.itemsFDivision = itemsFDivision;
      this.itemsFCvpt = itemsFCvpt;
      this.itemsFPegawai = itemsFPegawai;
    },
    setDialogState(value) {
      this.dialogShow = value;
    },
    save(andCloseDialog) {
      // console.log(andCloseDialog)
      if (this.isItemModified === false) {
        //Close aja
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
        return;
      }

      if (this.$refs.form.validate()) {
        if (this.formMode === FormMode.EDIT_FORM) {
          // console.log(`cek sebelum update >> ${this.itemModified.id}`)        </v-card-text>

          FKegiatanService.updateFKegiatan(this.itemModified).then(
            () => {
              // console.log(response.data)
              if (andCloseDialog) {
                this.$emit("eventFromFormDialogEdit", this.itemModified);
              }
            },
            (error) => {
              // console.log(error);
              this.formDialogOptions.errorMessage = error.response.data.message;
            }
          );
        } else {
          if (
            this.itemModified.fdivisionBean > 0 &&
            this.itemModified.description !== undefined &&
            this.itemModified.namaPekerjaan !== undefined
          ) {
            FKegiatanService.createFKegiatan(this.itemModified).then(
              (response) => {
                if (andCloseDialog) {
                  this.$emit("eventFromFormDialogNew", response.data);
                }
              },
              (error) => {
                this.formDialogOptions.errorMessage =
                  error.response.data.message;
              }
            );
          }
        } //endif
      } //endif validate
    },
    saveCreateOnly() {
      FKegiatanService.createFKegiatan(this.itemModified).then(
        (response) => {
          /**
           * dipaksa Save dan Update Dahulu
           */
          this.initializeEditMode(response.data);
          this.formMode = FormMode.EDIT_FORM;
        },
        (error) => {
          this.formDialogOptions.errorMessage = error.response.data.message;
        }
      );
    },
    closeForm() {
      if (!this.isItemModified) {
        this.dialogShow = false;
        this.$emit("eventFromFormDialog1", this.itemModified);
      } else {
        this.$refs.refCloseConfirmDialog.showDialog(
          " Sudah terdapat modifikasi data",
          "Tetap tutup dan reset perubahan?"
        );
      }
    },
    passingEventFromCloseConfirm(value) {
      if (value === "OKE") this.dialogShow = false;
    },
    initializeEditMode(item) {
      // this.itemDefault = item
      // this.itemModified = item

      this.formDialogOptions.errorMessage = "";

      FKegiatanService.getFKegiatanById(item.id).then(
        (response) => {
          // console.log(response.data)
          this.itemDefault = Object.assign({}, response.data);
          this.itemModified = response.data;

          this.$store.dispatch(
            "kegiatan/updateItemModified",
            this.itemModified
          );

          this.retrieveFiles();
        },
        (error) => {
          console.log(error);
        }
      );
    },
    retrieveFiles() {
      FKegiatanFileService.getAllFKegiatanFileByParent(
        this.itemModified.id
      ).then(
        (response) => {
          this.itemsFile = response.data;
        },
        (error) => {
          console.log(error.response);
        }
      );

      /**
       * second concept
       */
      FKegiatanMaterialService.getAllFKegiatanMaterialByParent(
        this.itemModified.id
      ).then(
        (response) => {
          // console.log(JSON.stringify(response.data))
          if (response.data.length > 0) {
            this.$store.dispatch(
              "kegiatan/updateListFKegiatanMaterial",
              response.data
            );
          } else {
            this.$store.dispatch("kegiatan/updateListFKegiatanMaterial", []);
          }
        },
        (error) => {
          this.$store.dispatch("kegiatan/updateListFKegiatanMaterial", []);
          console.log(error.response);
        }
      );
    },
    formattedCurrencyValue(prefix, value) {
      if (!value) {
        return "0";
      }
      // return "Rp." + parseFloat(value).toFixed(0).toLocaleString()
      return prefix + "" + parseFloat(value).toLocaleString();
    },

    lookupFDivision(fdivisionBean) {
      const str = this.itemsFDivision.filter((x) => x.id == fdivisionBean);
      if (str.length > 0) {
        return str[0].description;
      } else {
        return "-";
      }
    },
  },
};
</script>

<style scoped>
</style>